// src/tenant/tenantStorage.js
const LS_KEY = "@ea360/tenantId";
let memoryTenantId = null;

export function readTenantId() {
  if (memoryTenantId) return memoryTenantId;
  try {
    const v = localStorage.getItem(LS_KEY);
    if (v) {
      memoryTenantId = v;
      return v;
    }
  } catch {}
  return null;
}

export function writeTenantId(id) {
  memoryTenantId = id || null;
  try {
    if (id) localStorage.setItem(LS_KEY, id);
    else localStorage.removeItem(LS_KEY);
  } catch {}
}

export function getTenantFromSubdomain(mapping = {}) {
  try {
    const host = window.location.hostname; // ex: escola.educacaoalternativa360.com.br
    const parts = host.split(".");
    if (parts.length < 3) return null; // sem subdomínio
    const sub = parts[0]; // "escola", "web", "colegioalternativocolaco", etc.

    // Se tiver um mapeamento subdominio -> tenantId, use:
    if (mapping[sub]) return mapping[sub];

    // Se quiser aceitar o próprio subdomínio como tenantId (quando IDs legíveis),
    // retorne o sub. Caso não, mantenha null.
    return null;
  } catch {
    return null;
  }
}
